import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getDecodedRedirectPath } from '@hobs/utils/base64Utils/base64Utils';
import { changeCurrentExercise } from '@hobs/actions/exercises';
import Toast from '@hobs/components/Toast';

const EmailLink = ({ match, history, changeCurrentExercise }) => {
  useEffect(async () => {
    const encodedRedirecPath = match.params.redirect;
    const exerciseId = match.params.exerciseId;

    await checkAuthentication()
      .then(async () => {
        await handleLoggedInRedirection(encodedRedirecPath, exerciseId);
      })
      .catch(() => {
        handleLoggedOutRedirection(encodedRedirecPath, exerciseId);
      });
  }, []);

  const checkAuthentication = () => {
    const token = JSON.parse(localStorage.getItem('token'));

    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      validateStatus: status => {
        return status < 500;
      }
    };

    const API_URL =
      process.env.NODE_ENV === 'production' && global.config.baseApiURL
        ? global.config.baseApiURL
        : process.env.REACT_APP_API_URL;

    return new Promise((resolve, reject) => {
      axios(API_URL + '/Account/Claims', request)
        .then(async response => {
          if (response.status === 200) {
            resolve();
          } else if (response.status === 401) {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  };

  const handleLoggedInRedirection = async (encodedRedirecPath, exerciseId) => {
    await changeCurrentExercise(exerciseId)
      .then(() => {
        const redirectPath = getDecodedRedirectPath(encodedRedirecPath);
        history.push('/' + redirectPath);
      })
      .catch(() => {
        Toast.error('Cannot change current exercise');
      });
  };

  const handleLoggedOutRedirection = (encodedRedirecPath, exerciseId) => {
    history.push(`/login/${encodedRedirecPath}/${exerciseId}`);
  };

  return null;
};

EmailLink.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  changeCurrentExercise: PropTypes.func
};

const mapDispatchToProps = {
  changeCurrentExercise
};

export default connect(
  null,
  mapDispatchToProps
)(withRouter(EmailLink));
